import React, { useState } from 'react'
import { decryptString } from '../services/crypto'
// import { useSelector, useDispatch } from 'react-redux'
import { CContainer, CHeader } from '@coreui/react'
// import CIcon from '@coreui/icons-react'
// import { cilMenu } from '@coreui/icons'
import { AppBreadcrumb } from './index'
import { AppHeaderDropdown } from './header/index'
import './AppHeader.css'

const AppHeader = () => {
  // const dispatch = useDispatch()
  const [userName] = useState(decryptString('nome'))
  // const sidebarShow = useSelector((state) => state.sidebarShow)

  return (
    <CHeader position="sticky" className="mb-4">
      {/* <CHeaderToggler
        className="ps-1 show-hamburguer-menu"
        onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
      >
        <CIcon icon={cilMenu} size="lg" />
      </CHeaderToggler> */}
      <CContainer fluid>
        <AppBreadcrumb />
        <div className="user-info-logged">
          <span>{`Olá ${userName}`}</span>
          <AppHeaderDropdown />
        </div>
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
